import React from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";

interface MetadataCardProps {
  document: StratifyDocument;
}

export const MetadataCard: React.FC<MetadataCardProps> = ({ document }) => {
  const metadata = document.metadata.processing.result?.metadata;

  if (!metadata) return null;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Document Metadata
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {metadata.title && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Title
              </Typography>
              <Typography>{metadata.title}</Typography>
            </Stack>
          </Box>
        )}
        {metadata.author && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Author
              </Typography>
              <Typography>{metadata.author}</Typography>
            </Stack>
          </Box>
        )}
        {metadata.subject && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Subject
              </Typography>
              <Typography>{metadata.subject}</Typography>
            </Stack>
          </Box>
        )}
        {metadata.keywords && metadata.keywords.length > 0 && (
          <Box sx={{ flex: "1 1 100%" }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Keywords
              </Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {metadata.keywords.map((keyword, index) => (
                  <Chip
                    key={index}
                    label={keyword}
                    size="small"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Stack>
          </Box>
        )}
        {document.metadata.category && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Category
              </Typography>
              <Chip label={document.metadata.category.name} size="small" />
            </Stack>
          </Box>
        )}
      </Box>
    </Paper>
  );
};
